import React from 'react';
import { ReactComponent as CandidatesIcon } from '../../../../assets/icons/candidates.svg';
import { ReactComponent as SurveysIcon } from '../../../../assets/icons/survey.svg';
import { ReactComponent as ProspectsIcon } from '../../../../assets/icons/prospects.svg';
import { ReactComponent as PositionsIcon } from '../../../../assets/icons/position.svg';
import { ITab } from '../../../../common/models/common/ITab';

export const dashboardTabs: ITab[] = [
  {
    name: 'candidates',
    icon: () => <CandidatesIcon />
  },
  {
    name: 'positions',
    icon: () => <PositionsIcon />
  },
  {
    name: 'surveys',
    icon: () => <SurveysIcon />
  },
  {
    name: 'prospects',
    icon: () => <ProspectsIcon />
  }
];
